import ImgSvgIcon from '../img-svg-icon';
import './index.scss';

interface CustomButtonProps {
  text?: string;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  leftStyle?: React.CSSProperties;
  rightStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
}

/**
 * 自定义特殊按钮
 * @param text 前面区域文案内容
 * @param className 按钮容器可添加的classname
 * @param disabled 按钮是否禁用
 * @param onClick 点击
 * @param style 按钮容器自定义样式
 * @param leftStyle 左侧区域自定义样式
 * @param rightStyle 右侧区域自定义样式
 * @param textStyle 文字自定义样式
 * @returns
 */
export function CustomButton(props: CustomButtonProps) {
  const { 
    text = '', 
    className = '', 
    disabled = false, 
    onClick = null,
    style = {},
    leftStyle = {},
    rightStyle = {},
    textStyle = {}
  } = props;

  return (
    <div
      className={`custom-btn ${className} ${
        disabled ? 'custom-btn-disabled' : 'custom-btn-not-disable'
      }`}
      style={style}
      onClick={() => {
        !disabled && onClick && onClick();
      }}
    >
      <div className="custom-btn-left" style={leftStyle}>
        <div className="swiper" />
        <span className="custom-btn-text" style={textStyle}>{text}</span>
      </div>
      <div className="custom-btn-right" style={rightStyle}>
        <div className="swiper" />
        <div className="arrow-sign">
          <ImgSvgIcon
            className="span-icon arr1"
            width="24px"
            height="24px"
            iconUrl={
              'https://img.alicdn.com/imgextra/i3/O1CN01VQzbXM1gIYFDKR0Q5_!!6000000004119-55-tps-24-24.svg'
            }
          />
          <ImgSvgIcon
            className="span-icon arr2"
            width="24px"
            height="24px"
            iconUrl={
              'https://img.alicdn.com/imgextra/i3/O1CN01VQzbXM1gIYFDKR0Q5_!!6000000004119-55-tps-24-24.svg'
            }
          />
        </div>
      </div>
    </div>
  );
}
